import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=bcf8b2ca&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=bcf8b2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8b2ca",
  null
  
)

export default component.exports